import React from "react"
import { Redirect } from "react-router-dom"

// Dashboard
import Dashboard from "../pages/Dashboard/index"


//Ui
import UiNotifications from "../pages/Ui/ui-notifications"



// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"


// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Apps
import Calendario from "../paginas/calendario"

import UsuarioListado from '../paginas/usuario/usuarioListado'
import UsuarioFormulario from '../paginas/usuario/usuarioFormulario'
import RolListado from '../paginas/rol/rolListado'
import RolFormulario from '../paginas/rol/rolFormulario'
import PuestoListado from '../paginas/puesto/puestoListado'
import PuestoFormulario from '../paginas/puesto/puestoFormulario'
import EscolaridadListado from '../paginas/escolaridad/escolaridadListado'
import EscolaridadFormulario from '../paginas/escolaridad/escolaridadFormulario'
import UbicacionListado from '../paginas/ubicacion/ubicacionListado'
import UbicacionFormulario from '../paginas/ubicacion/ubicacionFormulario'
import ArticuloListado from '../paginas/articulo/articuloListado'
import ArticuloNoAsignado from '../paginas/articulo/articuloNoAsignado'
import ArticuloFormulario from '../paginas/articulo/articuloFormulario'
import ArticuloDetalles from '../paginas/articulo/articuloDetalles'
import MaterialListado from '../paginas/material/materialListado'
import MaterialFormulario from '../paginas/material/materialFormulario'
import CategoriaListado from "../paginas/categoria/categoriaListado"
import CategoriaFormulario from "../paginas/categoria/categoriaFormulario"
import ColaboradorListado from '../paginas/colaborador/colaboradorListado'
import ColaboradorFormulario from '../paginas/colaborador/colaboradorFormulario'
import TerritorioListado from "../paginas/territorio/territorioListado"
import TerritorioFormulario from "../paginas/territorio/territorioFormulario"
import DepartamentoAreaListado from "../paginas/departamentoArea/departamentoAreaListado"
import DepartamentoAreaFormulario from "../paginas/departamentoArea/departamentoAreaFormulario"
import EmpresaListado from "../paginas/empresa/empresaListado"
import EmpresaFormulario from "../paginas/empresa/empresaFormulario"
import TipoSolicitudListado from "../paginas/tipoSolicitud/tipoSolicitudListado"
import TipoSolicitudFormulario from "../paginas/tipoSolicitud/tipoSolicitudFormulario"
import ProyectoListado from "../paginas/proyecto/proyectoListado"
import ProyectoFormulario from "../paginas/proyecto/proyectoFormulario"
import Solicitud from "../paginas/solicitud/solicitud"
import SolicitudListado from "../paginas/solicitud/solicitudListado"
import SolicitudAsignar from "../paginas/solicitud/solicitudAsignar"
import SolicitudFormulario from "../paginas/solicitud/solicitudFormulario"
import SolicitudImportarExcel from "../paginas/solicitud/solicitudImportarExcel"
import SolicitudConcluirMasivo from "../paginas/solicitud/solicitudConcluirMasivo"
import vistaAsignado from "../paginas/vistaAsignado/vistaAsignado"
import grafica from "../paginas/grafica/grafica"
import reporte from "../paginas/reporteSolicitud/reporte"
import graficaCalificacion from "../paginas/grafica/graficaCalificacion"
import graficaTipoSolicitud from "../paginas/grafica/graficaTipoSolicitud"
import reporteFinalizado from "../paginas/reporteSolicitud/reporteFinalizado"
import reporteRecepcionSolicitud from "../paginas/reporteSolicitud/reporteRecepcionSolicitud"
import graficaHoras from "../paginas/graficaHora/graficaHoras"
import Proveedor from "../paginas/proveedor/proveedor"
import ProveedorLista from "../paginas/proveedor/proveedorLista"
import Timeout from "../paginas/exit/Timeout"
import articuloAsignar from "../paginas/inventario/articuloAsignar"
import asignarArticulo from "../paginas/inventario/asignarArticulo"
import listaAsignado from "../paginas/inventario/listaAsignado"
import editarAsignado from "../paginas/inventario/editarAsignado"
import tarjeta from "../paginas/tarjeta_colaborador/tarjeta"
import printAsignado from "../paginas/inventario/printAsignado"
import { trazabilidadArticulo } from "../paginas/trazabilidad/trazabilidadArticulo"
import { vistaTrazabilidad } from "../paginas/trazabilidad/vistaTrazabilidad"
import areaTrabajo from "../paginas/area_trabajo/areaTrabajo"
import formArea from "../paginas/area_trabajo/formArea"

import TarjetaResponsabilidadListado from "../paginas/tarjetaResponsabilidad/tarjetaResponsabilidadListado"
import TarjetaResponsabilidadFormulario from "../paginas/tarjetaResponsabilidad/tarjetaResponsabilidadFormulario"
import TarjetaResponsabilidadAceptar from "../paginas/tarjetaResponsabilidad/tarjetaResponsabilidadAceptar"
import TarjetaResponsabilidadAceptados from "../paginas/tarjetaResponsabilidad/tarjetaResponsabilidadAceptados"
import TarjetaResponsabilidadTraslado from "../paginas/tarjetaResponsabilidad/tarjetaResponsabilidadTraslado"
import ReporteHistorialArticuloAsignado from "../paginas/reportesArticulos/reporteHistorialArticuloAsignado"
import ReporteHistorialArticulo from "../paginas/reportesArticulos/reporteHistorialArticulo"
import ReporteArticuloMaster from "../paginas/reportesArticulos/reporteArticuloMaster"
import listaConcurrente from "../paginas/lista_solicitud_concurrente/listaConcurrente"
import formularioEnsamble from "../pages/ensamble/formularioEnsamble"
import programarSolicitud from "../paginas/concurrenciaSolicitud/programarSolicitud"
import listaActivosEnsamble from "../pages/ensamble/listaActivosEnsamble"
import ensamblePorDepartamento from "../pages/ensamble/ensamblePorDepartamento"
import ensambleDepartamento from "../pages/ensamble/ensambleDepartamento"
import GeneradorQR from "../paginas/generadorQR/generadorQR"
import ReporteHistorialMenu from "../paginas/usuario/reporteHistorialMenu"
import HistorialImportacionArticulo from "../paginas/articulo/historialImportacionArticulo"

const userRoutes = [
  { path: "/dashboard", component: Dashboard },

  // Paginas
  { path: '/calendario', component: Calendario },
  { path: '/usuarioListado', component: UsuarioListado },
  { path: '/usuarioFormulario', component: UsuarioFormulario },
  { path: '/rolListado', component: RolListado },
  { path: '/rolFormulario', component: RolFormulario },
  { path: '/puestoListado', component: PuestoListado },
  { path: '/puestoFormulario', component: PuestoFormulario },
  { path: '/escolaridadListado', component: EscolaridadListado },
  { path: '/escolaridadFormulario', component: EscolaridadFormulario },
  { path: '/ubicacionListado', component: UbicacionListado },
  { path: '/ubicacionFormulario', component: UbicacionFormulario },
  { path: '/articuloListado', component: ArticuloListado },
  { path: '/articuloNoAsignado', component: ArticuloNoAsignado },
  { path: '/articuloFormulario', component: ArticuloFormulario },
  { path: '/articuloDetalles/:id', component: ArticuloDetalles },
  { path: '/materialListado', component: MaterialListado },
  { path: '/materialFormulario', component: MaterialFormulario },
  { path: "/categoriaListado", component: CategoriaListado },
  { path: "/categoriaFormulario", component: CategoriaFormulario },
  { path: "/colaboradorListado", component: ColaboradorListado },
  { path: "/colaboradorFormulario", component: ColaboradorFormulario },
  { path: "/territorioListado", component: TerritorioListado },
  { path: "/territorioFormulario", component: TerritorioFormulario },
  { path: "/tipoSolicitudListado", component: TipoSolicitudListado },
  { path: "/tipoSolicitudFormulario", component: TipoSolicitudFormulario },
  { path: "/departamentoAreaListado", component: DepartamentoAreaListado },
  { path: "/departamentoAreaFormulario", component: DepartamentoAreaFormulario },
  { path: "/empresaListado", component: EmpresaListado },
  { path: "/empresaFormulario", component: EmpresaFormulario },
  { path: "/proyectoListado", component: ProyectoListado },
  { path: "/proyectoFormulario", component: ProyectoFormulario },
  { path: "/solicitud", component: Solicitud },
  { path: "/solicitudListado", component: SolicitudListado },

  { path: "/solicitudAdmin", component: SolicitudListado },
  { path: "/solicitudNueva", component: SolicitudListado },
  { path: "/solicitudAsignar", component: SolicitudAsignar },
  { path: "/solicitudEmergencias", component: SolicitudAsignar },
  { path: "/solicitudConcluir", component: SolicitudListado },
  { path: "/solicitudCalificar", component: SolicitudListado },
  { path: "/solicitudFinalizada", component: SolicitudListado },
  { path: "/solicitudDelDepartamento", component: SolicitudListado },
  { path: "/solicitudArchivado", component: SolicitudListado },
  { path: "/solicitudConcluirMasivo", component: SolicitudConcluirMasivo },

  { path: "/solicitudFormulario", component: SolicitudFormulario },
  { path: "/solicitudImportarExcel", component: SolicitudImportarExcel },
  { path: "/vistaAsignado", component: vistaAsignado },
  { path: "/graficar", component: grafica },
  { path: "/reporte", component: reporte },
  { path: "/graficaCalificacion",component: graficaCalificacion },
  { path: "/graficaTipoSolicitud",component: graficaTipoSolicitud },
  { path: "/reporteFinalizado", component: reporteFinalizado },
  { path: "/reporteRecepcionSolicitud", component: reporteRecepcionSolicitud },
  { path: "/graficaHoras", component: graficaHoras },
  { path: "/proveedor", component: Proveedor },
  { path: "/proveedorLista",component: ProveedorLista },
  { path: "/articuloAsignar",component: articuloAsignar },
  { path: "/asignarArticulo",component: asignarArticulo },
  { path: "/editarAsignado",component: editarAsignado },
  { path: "/listaAsignado",component: listaAsignado },
  { path: "/Timeout", component: Timeout },
  { path: "/tarjeta", component: tarjeta },
  { path: "/printAsignado", component: printAsignado },
  { path: "/trazabilidadArticulo", component: trazabilidadArticulo },
  { path: "/vistaTrazabilidad", component: vistaTrazabilidad},
  { path: "/areaTrabajo", component: areaTrabajo },
  { path: "/formArea", component: formArea },
  
  { path: "/tarjetaResponsabilidadListado", component: TarjetaResponsabilidadListado },
  { path: "/tarjetaResponsabilidadFormulario", component: TarjetaResponsabilidadFormulario },
  { path: "/tarjetaResponsabilidadAceptar", component: TarjetaResponsabilidadAceptar },
  { path: "/tarjetaResponsabilidadAceptados", component: TarjetaResponsabilidadAceptados },
  { path: "/tarjetaResponsabilidadTraslado", component: TarjetaResponsabilidadTraslado },
  { path: "/reporteHistorialArticuloAsignado", component: ReporteHistorialArticuloAsignado },
  { path: "/reporteHistorialArticulo", component: ReporteHistorialArticulo },
  { path: "/reporteArticuloMaster", component: ReporteArticuloMaster },
  { path: "/reporteArticuloUbicacion", component: ReporteArticuloMaster },
  { path: "/listaDeSolicitudesAutomaticas", component: listaConcurrente},
  { path: "/formularioEnsamble", component: formularioEnsamble },
  { path: "/listaActivosEnsamble", component: listaActivosEnsamble},
  { path: "/programarSolicitud", component: programarSolicitud },
  { path: "/ensamblePorDepartamento", component: ensamblePorDepartamento },
  { path: "/ensambleDepartamento", component: ensambleDepartamento },
  { path: '/generadorQR', component: GeneradorQR },
  { path: "/reporteHistorialMenu", component: ReporteHistorialMenu},
  { path: "/historialImportacionArticulo", component: HistorialImportacionArticulo },
    

  // //profile
  { path: "/profile", component: UserProfile },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [

  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register }
]

export { userRoutes, authRoutes }